import styled from 'styled-components'

const HeroSectionStyle = styled.section`
	--indTitleMTop: var(--sp4x);
	--typeAndTitleMTop: var(--sp5x);
	--typePadTB: var(--sp1-5x);
	--typePadLR: var(--sp3x);
	--heroImageMTop: var(--sp13x);
	--heroImageHeight: 50.6%;
	--backBtnMTop: var(--sp3x);

	//! Event variables
	--eventHeroSectionMTop: var(--sp3x);
	--rightContentMaxWidth: var(--sp121x);
	--eventHeroTextMTop: var(--sp2x);
	--eventHeroBannerMTop: var(--sp13x);
	--iconInfoDistance: var(--sp3x);
	--eventBannerPad: var(--sp4x);
	--partWidth: 50%;
	--eventHeroImageHeight: 135%;
	--eventHeroPadBot: var(--sp12x);

	.back-button {
		padding-top: var(--backBtnMTop);
	}

	&.event-background {
		background-color: var(--primaryColor1);
	}

	.type-and-title-wrapper {
		margin-top: var(--typeAndTitleMTop);

		.individual-type {
			border-radius: calc(var(--sp15x) / 2);
			padding: var(--typePadTB) var(--typePadLR);
		}

		.individual-title {
			margin-top: var(--indTitleMTop);
		}
	}

	.image-cont {
		margin-top: var(--heroImageMTop);
		padding-top: var(--heroImageHeight);

		img {
			border-radius: var(--borderRadiusSize);
		}
	}

	//! Event styles
	.event-hero-section {
		margin-top: var(--eventHeroSectionMTop);
		padding-bottom: var(--eventHeroPadBot);

		.event-hero-image {
			.image-cont {
				padding-top: var(--eventHeroImageHeight);
				margin-top: 0;

				img {
					border-radius: var(--borderRadiusSize);
				}
			}
		}

		.event-hero-info {
			display: flex;
			justify-content: flex-end;

			.event-internal {
				display: flex;
				align-items: center;
				width: var(--rightContentMaxWidth);

				.event-content {
					width: 100%;

					.event-hero-text {
						margin-top: var(--eventHeroTextMTop);
					}

					.event-banner {
						margin-top: var(--eventHeroBannerMTop);
						display: flex;
						flex-wrap: wrap;
						border-top: 1px solid var(--primaryColor9);
						border-bottom: 1px solid var(--primaryColor9);

						.left-part {
							width: var(--partWidth);
							display: flex;
							border-right: 1px solid var(--primaryColor9);
							padding: var(--eventBannerPad);
							padding-left: 0;

							i {
								margin-right: var(--iconInfoDistance);

								&:before {
									color: var(--primaryColor9);
								}
							}
						}

						.right-part {
							width: var(--partWidth);
							display: flex;
							padding: var(--eventBannerPad);
							padding-right: 0;

							i {
								margin-right: var(--iconInfoDistance);

								&:before {
									color: var(--primaryColor9);
								}
							}
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp4x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp10x);
		--heroImageHeight: 50.6%;
		--backBtnMTop: var(--sp3x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp2x);
		--rightContentMaxWidth: var(--sp91x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp10x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.8%;
		--eventHeroPadBot: var(--sp9x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp4x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp9x);
		--heroImageHeight: 50.8%;
		--backBtnMTop: var(--sp2x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp2x);
		--rightContentMaxWidth: var(--sp71x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp8x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 135.5%;
		--eventHeroPadBot: var(--sp20x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp3x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp7x);
		--heroImageHeight: 50.6%;
		--backBtnMTop: var(--sp2x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp3x);
		--rightContentMaxWidth: var(--sp70x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp8x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.7%;
		--eventHeroPadBot: var(--sp7x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp3x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp6x);
		--heroImageHeight: 50.6%;
		--backBtnMTop: var(--sp2x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp6x);
		--rightContentMaxWidth: var(--sp62x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp6x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.9%;
		--eventHeroPadBot: var(--sp12x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp3x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp5x);
		--heroImageHeight: 50.7%;
		--eventHeroPadBot: var(--sp11x);
		--backBtnMTop: var(--sp3x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp2x);
		--rightContentMaxWidth: var(--sp60x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp6x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.8%;

		.event-hero-image {
			width: 43.34% !important;
			padding-right: 0 !important;
		}

		.event-hero-info {
			width: calc(100% - 43.34%) !important;
			padding-left: 0 !important;
		}

		.event-banner {
			width: 100% !important;
		}

		.right-part {
			padding-left: var(--sp2x) !important;
		}

		.left-part {
			padding-right: var(--sp2x) !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--indTitleMTop: var(--sp3x);
		--typeAndTitleMTop: var(--sp4x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp5x);
		--heroImageHeight: 50.6%;
		--eventHeroPadBot: var(--sp7x);
		--backBtnMTop: var(--sp2x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp3x);
		--rightContentMaxWidth: 100%;
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp4x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 88.3%;

		.event-hero-image {
			display: flex;
			justify-content: center;

			.image-cont {
				width: 57.3vw;
			}
		}

		.event-hero-info {
			margin-top: var(--sp6x);
		}

		.event-banner {
			width: 100% !important;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--indTitleMTop: var(--sp2x);
		--typeAndTitleMTop: var(--sp4x);
		--typePadTB: var(--sp1-5x);
		--typePadLR: var(--sp3x);
		--heroImageMTop: var(--sp4x);
		--heroImageHeight: 121.4%;
		--eventHeroPadBot: var(--sp10x);
		--backBtnMTop: var(--sp3x);

		//! Event variables
		--eventHeroSectionMTop: var(--sp3x);
		--rightContentMaxWidth: 100%;
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp3x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp2x);
		--partWidth: 100%;
		--eventHeroImageHeight: 133.7%;

		.event-hero-info {
			margin-top: var(--sp4x);
		}

		.left-part {
			border-right: 0 !important;
			border-bottom: 1px solid var(--primaryColor9);
		}

		.right-part {
			padding-left: 0 !important;
		}
	}
`

export default HeroSectionStyle
